import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SharedModule } from '@shared/shared.module';
import { LoaderModule } from '@core/loader/loader.module';
import { SpreadSheetsModule } from '@grapecity/spread-sheets-angular';
import { LiquiditySourcesComponent } from './liquidity-sources.component';
import { CoreModule } from '@core/core.module';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    SharedModule,
    SpreadSheetsModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    LoaderModule
  ],
  declarations: [LiquiditySourcesComponent]
})
export class LiquiditySourcesModule {}
